import React from 'react';

const Benefits = () => {
  return (
    <>
      <section className='career-promo ptb-120 bg-light'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-10 col-md-12'>
              <div className='section-heading text-center'>
                <h4 className='h5 text-primary'>Why Join Us</h4>
                <h2>Benefits to your business</h2>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 col-lg-6'>
              <div className='single-feature d-flex mt-0 p-5 bg-white rounded-custom'>
                <span className='fas fa-house-user fa-2x text-primary'></span>
                <div className='ms-4 mt-2'>
                  <h5>High volume payment processing</h5>
                  <p className='mb-0'>
                    Leverage our high volume payment processing capacity across card and alternative payments{' '}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-lg-6'>
              <div className='single-feature d-flex mt-4 mt-xl-0 mt-lg-0 mt-md-0 p-5 bg-white rounded-custom'>
                <span className='fas fa-clock fa-2x text-primary'></span>
                <div className='ms-4 mt-2'>
                  <h5>Versatile payment methods</h5>
                  <p className='mb-0'>
                    Offer customers a versatile shopping experience with popular payment methods.
                    <br/>
                  </p>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-lg-6'>
              <div className='single-feature d-flex mt-4 p-5 bg-white rounded-custom'>
                <span className='fas fa-user-friends fa-2x text-primary'></span>
                <div className='ms-4 mt-2'>
                  <h5>Grow your revenue</h5>
                  <p className='mb-0'>
                    Our experts work closely with you to optimise your payment proposition and grow your revenue.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-lg-6'>
              <div className='single-feature d-flex mt-4 p-5 bg-white rounded-custom'>
                <span className='fas fa-briefcase-medical fa-2x text-primary'></span>
                <div className='ms-4 mt-2'>
                  <h5>Borderless online payments</h5>
                  <p className='mb-0'>
                    We help you identify global growth opportunities and break down payment barriers.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-lg-6'>
              <div className='single-feature d-flex mt-4 p-5 bg-white rounded-custom'>
                <span className='fas fa-briefcase-medical fa-2x text-primary'></span>
                <div className='ms-4 mt-2'>
                  <h5>Local payment options</h5>
                  <p className='mb-0'>
                    Create a strong payment foundation by offering your local audience their preferred way to pay.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-lg-6'>
              <div className='single-feature d-flex mt-4 p-5 bg-white rounded-custom'>
                <span className='fas fa-briefcase-medical fa-2x text-primary'></span>
                <div className='ms-4 mt-2'>
                  <h5>Multi-channel customer experience</h5>
                  <p className='mb-0'>
                    Create a seamless payments experience for customers online and in-store.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Benefits;
